import axios from 'axios';

// Shared, single-flight fetch of article_with_gallery.php. Several consumers
// need slices of the same payload (notification-bar pins, Home's articles/
// gallery/videos/focusseat, the panels' videos): each used to issue its own
// request, so a page load hit the endpoint 2-3 times. They now all await the
// same cached promise; the first caller in a TTL window does the network call.
//
// The TTL sits just under the notification bar's poll cadence so its next poll
// tick always lands outside the window and refreshes the cache for everyone.
// Errors are not cached — the entry is cleared so the next caller retries.
// Requests go through the app axios instance, so the eid pin is appended.

const ttl = () => (window.pinnedPollInterval || 35000) - 5000;

let cache = { lang: null, at: 0, promise: null };

export const fetchArticleGallery = () => {
  const lang = localStorage.getItem('lang') || 'zh_CN';
  const now = Date.now();
  if (!cache.promise || cache.lang !== lang || now - cache.at > ttl()) {
    const promise = axios
      .get(`article_with_gallery.php?lang=${lang}`)
      .then((res) => res.data || null)
      .catch(() => {
        if (cache.promise === promise) cache = { lang: null, at: 0, promise: null };
        return null;
      });
    cache = { lang, at: now, promise };
  }
  return cache.promise;
};
